import { UploadFile } from 'antd/lib/upload/interface';

export interface ICommonPayload {
  callback?: ICommonCallbackPayload;
}

export interface ICommonCallbackPayload {
  callbackOnSuccess?: (() => void) | ((result?: any) => void) | null;
  callbackOnFailure?: (error?: string) => void;
}

export type CallBack = (error: string | null, data?: unknown) => void;

export interface IPagination {
  readonly page?: number;
  readonly take: number;
  readonly itemCount: number;
  readonly pageCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
}

export interface IQueryWithPagination<E = any> {
  data: E;
  meta: IPagination;
}

/**
 *
 * @example
 * type test = Transform<IPagination, 'hasNextPage' | 'hasPreviousPage', null>;
 * const vip: test = {
 *  hasNextPage: null
 * };
 */
export type Transform<T, D = unknown, F extends keyof T = keyof T> = {
  [P in F]: D;
};

export type Nullable<T> = Transform<T, null>;

type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}${'' extends P ? '' : '.'}${P}`
    : never
  : never;

type Prev = [never, 0, 1, 2, 3, ...0[]];

/**
 * Intellisense paths of object
 * @see https://stackoverflow.com/questions/58434389/typescript-deep-keyof-of-a-nested-object
 */
export type Paths<T, D extends number = 10> = [D] extends [never]
  ? never
  : // eslint-disable-next-line @typescript-eslint/ban-types
  T extends object
  ? {
      [K in keyof T]-?: K extends string | number ? `${K}` | Join<K, Paths<T[K], Prev[D]>> : never;
    }[keyof T]
  : '';

export interface IComponentTheme {
  dark?: boolean;
}
export interface IUploadFile extends UploadFile {
  documentId?: string;
  userId?: string;
}

export type GeneralFunction = (...args: any) => any;

export enum OrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
